import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import LoginRedirect from './components/LoginRedirect';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import JobDetailPage from './pages/JobDetailPage';
import HowItWorksPage from './pages/HowItWorksPage';
import AiJobFinderPage from './pages/AiJobFinderPage';
import { Navigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import CvBuilderPage from './pages/CvBuilderPage';
import FitAnalysisPage from './pages/FitAnalysisPage';
import MockInterviewPage from './pages/MockInterviewPage';
import ApplicationsPage from './pages/ApplicationsPage';
import MeetingNotesPage from './pages/MeetingNotesPage';
import MagicLinkPage from './pages/MagicLinkPage';
import ImpersonateBridgePage from './pages/ImpersonateBridgePage';
import ImpersonationBanner from './components/ImpersonationBanner';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import LinkedInCallbackPage from './pages/LinkedInCallbackPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AboutPage from './pages/AboutPage';
import DistanceSalesPage from './pages/DistanceSalesPage';
import RefundPage from './pages/RefundPage';
import SubscriptionPage from './pages/SubscriptionPage';
import AbroadPage from './pages/AbroadPage';
import PaymentResultPage from './pages/PaymentResultPage';
import AdminApp from './admin/AdminApp';
import './App.css';

// admin.isbulsun.com aynı build/deploy'u paylaşır; hostname'e göre tamamen
// ayrı bir uygulama (kendi router, auth, layout) render edilir.
// Yerel test: admin.localhost:3000 (.localhost TLD hosts dosyasız çözülür).
const isAdminHost = window.location.hostname.startsWith('admin.');

function App() {
  if (isAdminHost) {
    return <AdminApp />;
  }

  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
        <div className="App">
          <ImpersonationBanner />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/nasil-calisir" element={<HowItWorksPage />} />
            <Route path="/yapay-zeka-is-bulsun" element={<AiJobFinderPage />} />
            <Route path="/ilan/:slug" element={<JobDetailPage />} />
            <Route path="/giris" element={<LoginRedirect />} />
            <Route path="/auth/magic-link" element={<MagicLinkPage />} />
            <Route path="/auth/impersonate" element={<ImpersonateBridgePage />} />
            <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/gizlilik" element={<PrivacyPage />} />
            <Route path="/kullanim-kosullari" element={<TermsPage />} />
            <Route path="/mesafeli-satis-sozlesmesi" element={<DistanceSalesPage />} />
            <Route path="/iptal-iade" element={<RefundPage />} />
            <Route path="/odeme-sonuc" element={<PaymentResultPage />} />
            {/* Eski adres — geriye dönük */}
            <Route path="/odeme/sonuc" element={<PaymentResultPage />} />
            <Route path="/auth/linkedin/callback" element={<LinkedInCallbackPage />} />
            <Route path="/panel" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/panel/profil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/panel/cv-olustur" element={<ProtectedRoute><CvBuilderPage /></ProtectedRoute>} />
            <Route path="/panel/uyum-analizi" element={<ProtectedRoute><FitAnalysisPage /></ProtectedRoute>} />
            <Route path="/panel/abonelik" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
            <Route path="/panel/yurtdisi" element={<ProtectedRoute><AbroadPage /></ProtectedRoute>} />
            {/* Kariyer Raporu kaldırıldı — CareerReport API'si hazır olunca geri eklenecek */}
            <Route path="/panel/raporlar" element={<Navigate to="/panel" replace />} />
            <Route path="/panel/basvurularim" element={<ProtectedRoute><ApplicationsPage /></ProtectedRoute>} />
            <Route path="/panel/toplantilarim" element={<ProtectedRoute><MeetingNotesPage /></ProtectedRoute>} />
            <Route path="/panel/mulakat" element={<ProtectedRoute><MockInterviewPage /></ProtectedRoute>} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
